import { highlightText } from '~/shared/lib/highlight-text'
import { Text } from '~/shared/ui'
import type { ClassificationEventProps } from '../../model'
import { EventNotes } from '../shared'

export function ClassificationEvent({
  event,
  searchQuery,
}: {
  event: ClassificationEventProps
  searchQuery: string
}) {
  return (
    <>
      <div className="flex flex-col gap-0.5 py-[3px]">
        <Text appearance="SUBTITLE2">{highlightText(event.title, searchQuery)}</Text>
        {event.descriptionText ? (
          <Text
            className="text-text-secondary"
            appearance="BODY2"
          >
            {highlightText(event.descriptionText, searchQuery)}
          </Text>
        ) : null}
        {event.source ? (
          <Text
            className="text-text-secondary"
            appearance="BODY2"
          >
            {highlightText(`Source: ${event.source}`, searchQuery)}
          </Text>
        ) : null}
      </div>
      {event.notes && event.userRole === 'person' && (
        <EventNotes
          notes={event.notes}
          searchQuery={searchQuery}
        />
      )}
    </>
  )
}
